type ProcessStatusIconProps = {
  className?: string
}

export const ProcessTimeIcon = ({ className }: ProcessStatusIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 3.375V6H8.625"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ProcessExternalLinkIcon = ({
  className,
}: ProcessStatusIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M10.125 4.875L10.1245 1.87547L7.125 1.875"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.375 5.625L10.125 1.875"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.625 6.375V9.75C8.625 9.84946 8.58549 9.94484 8.51517 10.0152C8.44484 10.0855 8.34946 10.125 8.25 10.125H2.25C2.15054 10.125 2.05516 10.0855 1.98484 10.0152C1.91451 9.94484 1.875 9.84946 1.875 9.75V3.75C1.875 3.65054 1.91451 3.55516 1.98484 3.48484C2.05516 3.41451 2.15054 3.375 2.25 3.375H5.625"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ProcessLoaderIcon = ({ className }: ProcessStatusIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    {[
      "M9 2.25V4.5",
      "M13.7728 4.22717L12.1816 5.81834",
      "M15.75 9H13.5",
      "M13.7728 13.7728L12.1816 12.1816",
      "M9 15.75V13.5",
      "M4.22729 13.7728L5.81847 12.1816",
      "M2.25 9H4.5",
      "M4.22729 4.22717L5.81847 5.81834",
    ].map((path) => (
      <path
        key={path}
        d={path}
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ))}
  </svg>
)
